module.exports = __webpack_public_path__ + "documents/SprintCompleteMyHome_T&Cs.pdf";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/termspage/pdf/SprintCompleteMyHome_T&Cs.pdf
// module id = 3526
// module chunks = 0